import 'element-closest';
import './md5.js';

var trackerAttributeName = 'data-dj-tracker-action';

/**
 * 监听点击事件, 自动事件上报
 */
function autoTrackClickEvent() {
    var $ = window.$ || window.jQuery || window.Zepto;
    if ($) {
        $(document.body).on('click', '[' + trackerAttributeName + ']', function(event) {
            sendClickView(event.currentTarget);
        });
    } else {
        document.body.addEventListener('click', function(event) {
            // 事件代理
            var trackerEl = event.target.closest('[' + trackerAttributeName + ']');
            if (trackerEl) {
                sendClickView(trackerEl);
            }
        }, false);
    }
}

/**
 * 上报点击事件
 * 
 * @param {HTMLElement} trackerEl 
 */
function sendClickView(trackerEl) {
    // 上报的事件名称
    var action = trackerEl.getAttribute(trackerAttributeName);
    if (action) {
        var trackerData = {};
        // 配置在元素上额外的上报数据
        var trackerOption = trackerEl.getAttribute('data-dj-tracker-option');
        if (trackerOption) {
            try {
                trackerData = eval('(' + trackerOption + ')');
            } catch (error) {
                console.error('tracker-helper', error);
            }
        }
        trackerData.action = action;

        trackClick(trackerData);
    }
}

/**
 * 主动上报
 * 
 * @param {string} type 上报类型: 
 * @param {object} data 上报的数据 
 * @see [【保姆月嫂】下单、评价页面埋点规范](http://confluence.daojia-inc.com/pages/viewpage.action?pageId=59660513)
 */
function trackEvent(type, data) {
    if (window.biTrackEvent) {
        window.biTrackEvent(type, data);
    }
}

/**
 * 上报点击
 * @param {object} data 
 */
function trackClick(data) {
    trackEvent('clickview', data);
}
/**
 * 上报PV
 * @param {object} data 
 */
function trackPageView(data) {
    trackEvent('pageview', data);
}

/**
 * 上报下单手机号码
 * 
 * @param {object} data 
 */
function trackOrderInfo(data) {
    var obj = {};
    if(window.md5 && data.mobile) {
        obj.order_phone = window.md5(data.mobile) ;
    }
    trackClick(obj);
}

window._trackOrderInfo = trackOrderInfo;

export {
    // 防止引入多次造成重复上报, 采用主动执行的方式来初始化
    autoTrackClickEvent,
    trackEvent,

    // 便捷方法
    trackClick,
    trackPageView,
    trackOrderInfo
};